import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChild,
  contentChildren,
  input,
  numberAttribute,
  TemplateRef,
} from '@angular/core';
import { BreadcrumbDefDirective } from './breadcrumb-def.directive';
import { Breadcrumb } from './breadcrumbs.model';

@Component({
  selector: 'app-breadcrumbs',
  imports: [NgTemplateOutlet],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent {
  public readonly breadcrumbs = input<Breadcrumb[]>([]);

  public readonly maxBreadcrumbs = input(3, { transform: numberAttribute });

  public readonly visibleBreadcrumbs = computed(() =>
    this.breadcrumbs().slice(-this.maxBreadcrumbs())
  );

  public readonly hiddenBreadcrumbs = computed(() => {
    const crumbs = this.breadcrumbs();
    const max = this.maxBreadcrumbs();

    if (crumbs.length <= max) {
      return [];
    }

    return crumbs.slice(0, crumbs.length - max);
  });

  public readonly nodes = contentChildren(BreadcrumbDefDirective);

  public readonly separatorTemplate = contentChild<TemplateRef<unknown>>('separator');

  public readonly menuTemplate = contentChild<TemplateRef<unknown>>('menu');
}
